export function setStorage(key, value) {
  localStorage.setItem(key, JSON.stringify(value))
}

export function getStorage(key, defaultValue = null) {
  const val = localStorage.getItem(key)
  if (val === null) return defaultValue
  try {
    return JSON.parse(val)
  } catch {
    return val
  }
}

export function removeStorage(key) {
  localStorage.removeItem(key)
}
